import React, { useContext } from "react";
import '../../stylesheet/activities.css'
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import TablePlaceholder from "../../Utils/TablePlaceholder";
import { getAllPatients } from "../../Utils/localStore";
import Topnav from "../others/Topnav";
import { FiChevronLeft } from "react-icons/fi";
import MoreActionButton from "./utils/MoreActionButton";
import { saveSelectedPatient, deletePatient } from "../../Utils/localStore";
import ToastContext from "../../context/toasterContex";

const PatientReport = ({ maxList, noTopnav }) => {
  const navigate = useNavigate();
  const { toast } = useContext(ToastContext)
  const [filter, setFilter] = useState("all");
  const [allPatients, setAllPatients] = useState([])
  const [showDelete, setShowDelete] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)

  const getLocalData = async () => {
    let response
    try {
      await getAllPatients().then(resp => response = resp)
      return setAllPatients(response)
    } catch (error) {
      toast.error(error, { position: toast.POSITION.TOP_CENTER })
      throw new Error(error)
    }
  }
  useEffect(() => {
    getLocalData()
    return () => '';
  }, [])
  const handleChildAction = async (mode, details) => {
    if (mode === 'view') {
      try {
        // await dispatch(setCurrentPatient(details))
        localStorage.setItem('patientEditMode', true)
        await saveSelectedPatient(details).then(resp => {
          navigate("/patients/details");
        })
      } catch (error) {
        console.log({ error });
      }
    } else if (mode === 'edit') {
      try {
        await saveSelectedPatient(details).then(resp => {
          localStorage.setItem('patientEditMode', true)
          navigate('/patients/new-patient')
        })
      } catch (error) {
        console.log({ error });
      }
    } else if (mode === 'delete') {
      try {
        setShowDelete(true)
        setSelectedRecord(details)
      } catch (error) {
        console.log({ error });
      }
    }
  }
  const handleDeleteAction = async () => {
    try {
      const response = await deletePatient(selectedRecord.localID).then(resp => {
        getLocalData()
        toast.success('Record deleted successfully', { position: toast.POSITION.TOP_CENTER })
      })
    } catch (error) {
      toast.error('Something went wrong, please try again later', { position: toast.POSITION.TOP_CENTER })
    }
    setShowDelete(false)
  }
  const handlePatientInfo = () => {
    navigate("/patients/details");
  };
  const filteredItems = allPatients
    .filter((item) => {
      if (filter === "all") {
        return item;
      } else if (filter === 'Active') {
        return item.status == 'Active'
      } {
        return item.status === 'InActive';
      }
    })
  // .slice(0, 9);
  const delRef = useRef(null)
  const dropdownRef = useRef(null);
  return (
    <>
      <div>
        {!noTopnav && <Topnav />}
      </div>
      <div className="  mr-4 mt-4">
        {
          !noTopnav &&
          <div className="flex justify-between align-middle items-center px-4">
            <div className="mt-4">
              <button onClick={(e) => {
                e.preventDefault()
                navigate('/patients')
              }}>
                <div className="flex items-center">
                  <FiChevronLeft className="text-md" size={30} /> Back
                </div>
              </button>
            </div>
            <div>
              <button onClick={(e) => { e.preventDefault(); navigate('/patients/new-patient') }} className="bg-primary text-white font-bold p-3 rounded-md">Add New</button>
            </div>
          </div>
        }
      </div>
      <div className={noTopnav ? '' : 'report'}>
        <div className="report_header w-max lg:w-full">
          <div className="button">
            <button
              className={filter === "all" ? "active" : ""}
              onClick={() => setFilter("all")}
            >
              All Patients
            </button>
            <button
              className={filter === "Active" ? "active" : ""}
              onClick={() => setFilter("Active")}
            >
              Active Patients
            </button>
            <button
              className={filter === "Inactive" ? "active" : ""}
              onClick={() => setFilter("Inactive")}
            >
              Inactive Patients
            </button>
          </div>
          <button onClick={handlePatientInfo}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M3 7H21"
                stroke="#009FE3"
                strokeWidth="1.5"
                strokeLinecap="round" />
              <path
                d="M6 12H18"
                stroke="#009FE3"
                strokeWidth="1.5"
                strokeLinecap="round" />
              <path
                d="M10 17H14"
                stroke="#009FE3"
                strokeWidth="1.5"
                stroke-inecap="round" />
            </svg>
            Filter
          </button>
        </div>
        <div className="report_table">
          {
            filteredItems && filteredItems.length ? (
              <>
                {
                  showDelete &&
                  <dialog ref={delRef}>
                    <div className="w-[300px] bg-white rounded-md p-8 border">
                      <p className="text-center mb-6">Are you sure you want to delete this record?</p>
                      <div className="flex justify-between">
                        <button onClick={(e) => {
                          e.preventDefault()
                          handleDeleteAction()
                        }} className="rounded-md text-white bg-primary p-2">
                          Confirm
                        </button>
                        <button autoFocus className="p-2" onClick={(e) => {
                          e.preventDefault()
                          setShowDelete(false)
                        }}>
                          Cancel
                        </button>
                      </div>
                    </div>
                  </dialog>
                }
                <table>
                  <thead>
                    <tr>
                      <th className="tag_1">
                        <input type="checkbox" name="Prescription ID" id="pre_id" />{" "}
                        <span>Patient ID</span>
                      </th>
                      <th>Date </th>
                      <th>Patient Name</th>
                      <th>Last Activity</th>
                      <th className="status_head">
                        <span>Status</span>
                      </th><th className="status_head">
                        <span>Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      filteredItems.length &&
                      filteredItems.slice(0, maxList).map((item, index) => (
                        <tr className={`${item.status}`} key={item.localID + 'localId'}>
                          <td>
                            {" "}
                            <span className="tag">
                              <input type="checkbox" name="Prescription ID" id="pre_id" />
                              <button id={index + 'patient_id'} onClick={(e) => {
                                e.preventDefault()
                                saveSelectedPatient(item).then(() => {
                                  navigate(`/patients/details?id=${+item.localID}`);
                                })
                              }
                              }>
                                #{+index + 1}
                              </button>
                              {
                                item.synced ?
                                  <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">Synced</span>
                                  :
                                  <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">offline</span>
                              }
                            </span>
                          </td>
                          <td>{item.joinedDate}</td>
                          <td>
                            <button id={index + 'patient_id'} onClick={(e) => {
                              e.preventDefault()
                              saveSelectedPatient(item).then(() => {
                                navigate("/patients/details");
                              })
                            }}>
                              {item.patientName}
                            </button>
                          </td>
                          <td>{item.joinedDate}</td>
                          <td className="status">
                            <span className={`stats ${item.status}`}>{item.status}</span>
                          </td>
                          <td >
                            <div ref={dropdownRef} className="text-center">
                              <MoreActionButton onAction={handleChildAction} details={item} />
                            </div>

                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </>
            )
              :
              <TablePlaceholder lost="You have no record, please create records to view" />
          }
        </div>
      </div>
    </>
  );
};

export default PatientReport;
